export const T = {
  en_GB: { loading: "Loading flow...", flow: "Flow", flowInstance: "Flow Instance" },
  nb_NO: { loading: "Laster flyt...", flow: "Flyt", flowInstance: "Flytforekomst" },
} as const;
